var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.snackbar,"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.snackbarText)+" "),_c('v-btn',{attrs:{"dark":"","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" Close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }